<script>
    import { onMount } from "svelte";
    import IconAdd from "../icons/IconAdd.svelte";
    import { CustomerStore, Authentication } from '../stores'
	import Customer from "./Customer.svelte"
	import CustomerCru from "./CustomerCru.svelte"
    
    let customerFromApi = [];
    let authenthicationData = '';
    let modal;
    let customerSearch = '';
    let editSelectedCustomer;

	onMount(async function () {
        loadCustomers();
    });

    async function loadCustomers() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/customer';
        if(customerSearch) url = url + '/' + customerSearch;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        CustomerStore.set(data);
        CustomerStore.subscribe((data) => customerFromApi = data);
    }

    function addCustomer() {
        editSelectedCustomer = {id: 0, firstName: '', lastName: '', address: '', phone: '', mobile: '', email: '', remark: ''};
        modal.show();
    }

    function editCustomer(editedCustomer) {
        editSelectedCustomer = editedCustomer.detail.editedCustomerItem;
        modal.show();
    }

    function sellOffConfirmed() {
        
    }
</script>

<nav>
    <ul>
        <li><h1>Kunden</h1></li>
        <input class="custSearch" bind:value={customerSearch} on:input={() => loadCustomers()}/>
        <li><IconAdd on:clicked={addCustomer}/></li>
    </ul>
</nav>

<CustomerCru bind:this={modal} customer={editSelectedCustomer} on:accepted={loadCustomers}/>

<div>
    {#each customerFromApi as customer}
        <Customer customer={customer} 
            on:customerDeleted={loadCustomers} 
            on:editCustomer={(editedCustomer) => editCustomer(editedCustomer)}
            on:sellOffConfirmed={sellOffConfirmed}/>
    {/each}
</div>

<style>
    .custSearch {
        max-width: 50%;
        margin-top: 10px;
        margin-right: 10px;
    }

    h1 {
        margin-left: -30px;
    }

    ul {
        display: flex;
        justify-content: flex;
        list-style: none;
        align-items: center;
    }

    li {
        display: block;
        margin-right: 1em;
    }

    nav {
        margin-top: -70px;
        margin-bottom: -20px;
    }
</style>